<header class="panel-header panel-header-compact">
  <h1>Exercise Scope</h1>
  <p>Define who participates and what format the exercise takes.</p>
</header>

<div class="scope-form">
  <section class="scope-section">
    <h2>Target participants</h2>

    <div class="chip-group participant-chip-group">
      <button
        type="button"
        class="selection-chip participant-chip"
        *ngFor="let participant of participantOptions"
        [class.selected]="isParticipantSelected(participant.id)"
        (click)="toggleParticipantSelection(participant.id)"
      >
        {{ participant.label }}
      </button>
    </div>
  </section>

  <section class="scope-section">
    <h2>Exercise format</h2>

    <div class="format-grid">
      <button
        type="button"
        class="format-card"
        *ngFor="let format of exerciseFormats"
        [class.selected]="isExerciseFormatSelected(format.id)"
        (click)="selectExerciseFormat(format.id)"
      >
        <span class="format-icon">
          <img [src]="format.icon" alt="" />
        </span>

        <span class="format-copy">
          <strong>{{ format.title }}</strong>
          <span>{{ format.description }}</span>
        </span>
      </button>
    </div>
  </section>

  <label class="field">
    <span>Custom Exercise Type ( Optional )</span>
    <input
      type="text"
      [value]="customExerciseType"
      placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
      (input)="updateCustomExerciseType($event)"
    />
  </label>

  <section class="scope-section objective-section">
    <h2>Custom Objectives</h2>

    <div class="objective-controls">
      <div class="objective-select" [class.open]="isObjectiveDropdownOpen">
        <div class="objective-trigger" (click)="openObjectiveDropdown()">
          <span class="objective-search-icon">⌕</span>

          <input
            type="text"
            autocomplete="off"
            [value]="objectiveSearchTerm"
            placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
            (focus)="openObjectiveDropdown()"
            (click)="$event.stopPropagation()"
            (input)="updateObjectiveSearch($event)"
          />

          <button
            type="button"
            class="objective-toggle"
            aria-label="Toggle custom objectives"
            (click)="toggleObjectiveDropdown($event)"
          >
            <span class="objective-toggle-icon"></span>
          </button>
        </div>

        <div
          class="objective-dropdown"
          *ngIf="isObjectiveDropdownOpen"
          (click)="$event.stopPropagation()"
        >
          <label
            class="objective-option"
            *ngFor="let objective of filteredObjectiveOptions"
          >
            <input
              type="checkbox"
              [checked]="isObjectivePending(objective.id)"
              (change)="togglePendingObjective(objective.id)"
            />
            <span class="checkbox-box"></span>
            <span class="objective-option-label">{{ objective.label }}</span>
          </label>

          <button
            type="button"
            class="objective-add-new"
            (click)="addCustomObjective()"
            [disabled]="!canAddCustomObjective"
          >
            <span class="objective-add-new-icon">+</span>
            <span>Add New</span>
          </button>
        </div>
      </div>

      <button
        type="button"
        class="objective-add-button"
        (click)="commitObjectives()"
        [disabled]="!hasPendingObjectives"
      >
        Add
      </button>
    </div>

    <div
      class="chip-group participant-chip-group"
      *ngIf="selectedObjectives.length > 0"
    >
      <button
        type="button"
        class="selection-chip participant-chip selected"
        *ngFor="let objective of selectedObjectives"
        (click)="removeSelectedObjective(objective.id)"
        [attr.aria-label]="'Remove ' + objective.label"
      >
        {{ objective.label }}
      </button>
    </div>
  </section>
</div>
